import connectivityMonitorMessages from
  'ringcentral-integration/modules/ConnectivityMonitor/connectivityMonitorMessages';

export default {
  [connectivityMonitorMessages.disconnected]: 'Perte de la connexion réseau.',
};
